import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';

type Props = {
  show?: boolean;
  zIndex: number;
  children?: Node;
  onClick?: () => void;
  classList: Array<any | false>;
} & React.ReactElement;

const getBaseStyle = (zIndex: number) => ({
  position: 'fixed',
  zIndex,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  top: 0,
  left: 0,
  height: '100vh',
  width: '100vw',
  transition: 'all 100ms linear'
});

const ScreenOverlay = ({ show, zIndex, children, classList, onClick, ...props }: Props | any) => {
  const classes = useStyles()();
  return (
    <div
      style={getBaseStyle(zIndex)}
      className={clsx(show ? classes.show : classes.hide, classList)}
      onClick={onClick}
      {...props}
    >
      {children && children}
    </div>
  );
};

ScreenOverlay.defaultProps = {
  zIndex: 8,
  show: true,
  classList: []
};

const useStyles = () =>
  makeStyles(() => ({
    show: {
      visibility: 'visible',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    hide: {
      visibility: 'hidden',
      backgroundColor: 'rgba(0, 0, 0, 0)',
      '@media print': {
        display: 'none !important'
      }
    }
  }));

export default ScreenOverlay;
